// Get all the accordion sections
const sections = document.querySelectorAll('.accordion__section');

// Add a click event listener to each section's header
sections.forEach(section => {
    const header = section.querySelector('.accordion__header');
    const items = section.querySelector('.accordion__panel');

    header.addEventListener('click', (e) => {
        e.preventDefault();
        // Toggle the active class on the clicked header
        header.classList.toggle('active');

        // Toggle the visibility of the items
        // items.style.display = (items.style.display === 'block') ? 'none' : 'block';
        items.style.visibility = (items.style.visibility === 'visible') ? 'hidden' : 'visible';
        items.style.height = (items.style.height === 'auto') ? 0 : 'auto';

        // Close other accordion items
        sections.forEach(otherSection => {
            const otherHeader = otherSection.querySelector('.accordion__header');
            const otherItems = otherSection.querySelector('.accordion__panel');

            if (otherSection !== section) {
                otherHeader.classList.remove('active');
                otherItems.style.visibility = 'hidden';
                otherItems.style.height = '0';
            }
        });
    });
});